export default __webpack_public_path__ + "static/media/resources-and-production-3.e94e27c3.png";